(function () {
  if (window.__spQtyRoll) return;
  window.__spQtyRoll = true;

  var SEL = '.buttoned-input input[type="number"]';
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var DUR = 420;
  var STEP = 40;
  var proto = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)');

  function digitHtml(ch) {
    return '<span class="sp-qty-digit"><span class="sp-qty-face__glyph">' + ch + '</span></span>';
  }

  function render(face, text) {
    face.innerHTML = text.split('').map(digitHtml).join('');
    face.setAttribute('data-v', text);
  }

  function roll(slot, ch, d, lag) {
    slot.getAnimations({ subtree: true }).forEach(function (a) { a.finish(); });
    var glyphs = slot.querySelectorAll('.sp-qty-face__glyph');
    for (var i = 0; i < glyphs.length - 1; i++) glyphs[i].remove();
    var oldG = slot.querySelector('.sp-qty-face__glyph');
    var w0 = slot.getBoundingClientRect().width;
    var newG = document.createElement('span');
    newG.className = 'sp-qty-face__glyph';
    newG.textContent = ch;
    slot.appendChild(newG);
    var w1 = newG.getBoundingClientRect().width;
    if (oldG) {
      oldG.style.position = 'absolute';
      oldG.style.left = '0';
      oldG.style.top = '0';
      oldG.animate([{ transform: 'none', opacity: 1 }, { transform: 'translateY(' + (-100 * d) + '%)', opacity: 0 }],
        { duration: DUR, easing: EASE, delay: lag, fill: 'forwards' }).onfinish = function () { oldG.remove(); };
    }
    if (w0 !== w1) slot.animate([{ width: w0 + 'px' }, { width: w1 + 'px' }], { duration: DUR, easing: EASE, delay: lag });
    newG.animate([{ transform: 'translateY(' + (100 * d) + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }],
      { duration: DUR, easing: EASE, delay: lag, fill: 'backwards' });
  }

  function update(input) {
    var face = input._spQtyFace;
    var text = String(proto.get.call(input));
    var old = face.getAttribute('data-v');
    if (old === text) return;
    var a = Number(old), b = Number(text);
    if (old == null || old === '' || text === '' || isNaN(a) || isNaN(b) || (reduce && reduce.matches) || !face.animate ||
        document.activeElement === input) {
      render(face, text);
      return;
    }
    var d = b >= a ? 1 : -1;
    face.setAttribute('data-v', text);
    var n = Math.max(old.length, text.length);
    var from = old.padStart(n, ' '), to = text.padStart(n, ' ');
    while (face.children.length < n) face.insertAdjacentHTML('afterbegin', digitHtml(''));
    var lag = 0;
    for (var i = n - 1; i >= 0; i--) {
      var slot = face.children[i];
      if (from[i] === to[i]) continue;
      if (to[i] === ' ') {
        var gone = slot;
        gone.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DUR * 0.5, easing: EASE, delay: lag, fill: 'forwards' });
        gone.animate([{ width: gone.getBoundingClientRect().width + 'px' }, { width: '0px' }],
          { duration: DUR, easing: EASE, delay: lag, fill: 'forwards' }).onfinish = function () { this.effect.target.remove(); };
      } else {
        roll(slot, to[i], d, lag);
      }
      lag += STEP;
    }
  }

  function enhance(input) {
    if (input._spQtyFace || !proto || !proto.get) return;
    var wrap = document.createElement('span');
    wrap.className = 'sp-qty';
    var face = document.createElement('span');
    face.className = 'sp-qty-face';
    face.setAttribute('aria-hidden', 'true');
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);
    wrap.appendChild(face);
    input._spQtyFace = face;
    var cs = getComputedStyle(input);
    face.style.fontFamily = cs.fontFamily;
    face.style.fontSize = cs.fontSize;
    face.style.fontWeight = cs.fontWeight;
    face.style.letterSpacing = cs.letterSpacing;
    face.style.color = cs.color;
    render(face, String(proto.get.call(input)));
    try {
      Object.defineProperty(input, 'value', {
        configurable: true,
        get: function () { return proto.get.call(this); },
        set: function (v) { proto.set.call(this, v); update(this); }
      });
    } catch (e) {  }
    input.addEventListener('input', function () { update(input); });
    input.addEventListener('change', function () { update(input); });
    input.addEventListener('blur', function () { render(face, String(proto.get.call(input))); });
    wrap.classList.add('is-ready');
  }

  function scan(root) {
    if (root.matches && root.matches(SEL)) enhance(root);
    if (root.querySelectorAll) root.querySelectorAll(SEL).forEach(enhance);
  }

  function boot() {
    scan(document);
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
